import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, unref as _unref } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "main_left_con lg:pr-10"
}
const _hoisted_2 = { class: "main_middle_con" }
const _hoisted_3 = {
  key: 1,
  class: "main_right_con lg:pl-7 lg:order-2 -order-1"
}

import { 
    IonPage, 
    IonContent, 
} from '@ionic/vue';

import TopNavigation from '@/partials/TopNavigation.vue';
import BottomNavigation from '@/partials/BottomNavigation.vue';
import SecurityFeatureModal from "@/components/modals/SecurityFeatureModal.vue"
import { useSecurityFeature } from '@/store/securityFeature';
import { computed, onBeforeMount, ref, watch } from 'vue';
import { useNetworkStore } from "@/store/network";
import { useSessionCookie } from '@/helpers/useSessionCookie';


export default /*#__PURE__*/_defineComponent({
  __name: 'UserLayout',
  props: {
    hasBack: {
        type: Boolean,
        default: false
    },
    backLink: {
        type: String,
        default: null
    },
    backTitle: {
        type: String,
        default: 'Back'
    },
    pageTitle: {
        type: String,
        default: null
    },
    showFooter: {
        type: Boolean,
        default: true,
    },
    color: {
        type: String
    },
    hasLeftCon: {
        type: Boolean,
        default: false,
    },
    hasRightCon: {
        type: Boolean,
        default: false,
    },
    mainCustomClass: {
        type: String,
        default: null,
    },
    hasBackClass: {
        type: String,
        default: "flex justify-between items-center",
    }
},
  setup(__props) {



const networkStore = useNetworkStore();
const isNetworkAvailable = computed(() => networkStore.isNetworkAvailable);
const title = ref("Input your password!");
const { setSessionCookie, getSessionCookie } = useSessionCookie('hasPasswordBlocker');

watch(
    () => useSecurityFeature().isPasswordBlocker,
    (status) => {
        if (isNetworkAvailable.value && status) {
            useSecurityFeature().isActivated = status;
            title.value = "Input your password!";
        }
    }
);

// document.addEventListener('visibilitychange', function() {
//     if (document.visibilityState === 'visible') {
//         // Show password prompt here
//         useSecurityFeature().isPasswordBlocker = true;
//         sessionStorage.setItem('hasPasswordBlocker', true)
//     }
// });
window.addEventListener('load', () => {
    const hasPasswordBlocker = eval(sessionStorage.getItem('hasPasswordBlocker'));
    if (hasPasswordBlocker) {
        useSecurityFeature().isPasswordBlocker = true;
    }
});
window.addEventListener('beforeunload', (event) => {
    if (!isNetworkAvailable.value) {
        event.preventDefault();
        event.returnValue = null;
        return null;
    }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(TopNavigation, {
        hasBack: __props.hasBack,
        backLink: __props.backLink,
        backTitle: __props.backTitle,
        pageTitle: __props.pageTitle,
        hasBackClass: __props.hasBackClass
      }, {
        lowerMiddle: _withCtx(() => [
          _renderSlot(_ctx.$slots, "lowerMiddle")
        ]),
        lowerRight: _withCtx(() => [
          _renderSlot(_ctx.$slots, "lowerRight")
        ]),
        _: 3
      }, 8, ["hasBack", "backLink", "backTitle", "pageTitle", "hasBackClass"]),
      _createVNode(_unref(IonContent), { fullscreen: true }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass(["grid lg:mx-6 mx-4 min-h-screen pb-16", [
                    (__props.hasLeftCon && __props.hasRightCon)
                        ? 'grid-cols-[210px_auto_368px]'
                        : __props.hasLeftCon
                        ? 'lg:grid-cols-[210px_auto] grid-cols-1'
                        : __props.hasRightCon
                        ? 'lg:grid-cols-[auto_368px] grid-cols-1'
                        : 'grid-cols-1',
                    __props.mainCustomClass
                ]])
          }, [
            (__props.hasLeftCon)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _renderSlot(_ctx.$slots, "leftContent")
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_2, [
              _renderSlot(_ctx.$slots, "default")
            ]),
            (__props.hasRightCon)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _renderSlot(_ctx.$slots, "rightContent")
                ]))
              : _createCommentVNode("", true)
          ], 2),
          (__props.showFooter)
            ? (_openBlock(), _createBlock(BottomNavigation, { key: 0 }))
            : _createCommentVNode("", true),
          _createVNode(SecurityFeatureModal, { title: title.value }, null, 8, ["title"])
        ]),
        _: 3
      })
    ]),
    _: 3
  }))
}
}

})